import { defineComponent, computed } from "vue";
import isObject from "./component-library238.mjs";
import InputWrapper from "./component-library19.mjs";
import { useLabeledInput } from "./component-library239.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "select-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    inlineLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    promptValue: { default: "" },
    prompt: { default: void 0 },
    hidePrompt: { type: Boolean, default: false },
    selectClass: { default: void 0 },
    autocomplete: { default: void 0 },
    name: { default: void 0 },
    options: null
  },
  emits: ["input", "select"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const { inputWrapperProps, inputFieldProps, focus } = useLabeledInput(props, emits);
    const inputOrCustomInputClass = computed(() => {
      if (props.selectClass)
        return props.selectClass;
      return props.inputClass;
    });
    const sanitizedOptions = computed(() => {
      return props.options.map((option) => {
        if (isObject(option))
          return option;
        return { label: option, value: option };
      });
    });
    const onInput = (event) => {
      var _a;
      const value = ((_a = event.target) == null ? void 0 : _a.value) || null;
      const selection = sanitizedOptions.value.find((option) => option.value === value);
      emits("input", value);
      emits("select", selection);
    };
    expose({ focus, onInput });
    return { __sfc: true, props, emits, inputWrapperProps, inputFieldProps, focus, inputOrCustomInputClass, sanitizedOptions, onInput, InputWrapper };
  }
});
export {
  _sfc_main as default
};
